// Importación automática de todas las imágenes de la carpeta
function importAllImages(r) {
  return r.keys().map(r);
}

// Importa todas las imágenes de la carpeta /images
// Nota: Esto funciona con webpack y require.context
// Si estás usando Create React App, esto debería funcionar correctamente
const galleryImages = (() => {
  try {
    // Intenta importar todas las imágenes del directorio /images
    // El primer parámetro es el directorio, el segundo indica si debe buscar en subdirectorios,
    // y el tercero es una expresión regular para filtrar archivos
    const images = require.context('/public/images/galeria', false, /\.(png|jpe?g|gif|webp)$/);
    const data = importAllImages(images);
    console.log("Imágenes cargadas:", data);
    return data;
  } catch (error) {
    console.error('Error al importar imágenes:', error);
    // Fallback a la lista manual en caso de error
    return [
      '/images/pablo.png',
      // Puedes mantener la lista manual como respaldo
    ];
  }
})();

// Función simplificada para precargar imágenes
export const preloadImagesInBatches = (images, batchSize = 3, delayBetweenBatches = 1000) => {
  let currentBatch = 0;
  const totalBatches = Math.ceil(images.length / batchSize);

  const preloadBatch = (batchIndex) => {
    const start = batchIndex * batchSize;
    const end = Math.min(start + batchSize, images.length);

    for (let i = start; i < end; i++) {
      const img = new Image();
      img.src = images[i];
    }

    if (batchIndex + 1 < totalBatches) {
      setTimeout(() => preloadBatch(batchIndex + 1), delayBetweenBatches);
    }
  };

  // Iniciar la precarga con el primer lote
  preloadBatch(0);
};

export default galleryImages; 